<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "MarginListIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
